export default __webpack_public_path__ + "static/media/link.8a28d8c8.svg";